import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <p>© 2025 Sanjana Khanal. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
